<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [{}],
    },
    flat: {
      type: Boolean,
      default: false,
    },
    accordion: {
      type: Boolean,
      default: false,
    },
    focusable: {
      type: Boolean,
      default: false,
    },
    inset: {
      type: Boolean,
      default: false,
    },
    popout: {
      type: Boolean,
      default: false,
    },
    tile: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
  },
  data: () => ({ activePanels: [] }),
  computed: {
    props() {
      return {
        flat: this.flat,
        accordion: this.accordion,
        focusable: this.focusable,
        inset: this.inset,
        popout: this.popout,
        tile: this.tile,
        multiple: this.multiple,
      }
    },
  },
  mounted() {
    if (this.expanded && this.items?.length)
      this.activePanels = this.items.map((_, index) => index)
  },
}
</script>

<template>
  <v-expansion-panels v-model="activePanels" v-bind="props">
    <v-expansion-panel v-for="(item, index) in items" :key="index">
      <v-expansion-panel-header :class="headerClass">
        <template v-slot:actions="{ open }">
          <slot name="header-actions" :open="open" :item="item"></slot>
        </template>
        <slot name="header-content" :item="item"></slot>
      </v-expansion-panel-header>
      <v-expansion-panel-content :class="contentClass">
        <slot name="panel-content" :item="item"></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
